import React, { useEffect } from 'react';

const AdSenseUnit = ({ adClient, adSlot, adFormat = "auto", adLayout, fullWidthResponsive = true, style = { display: 'block' }, className = "adsbygoogle" }) => {
  useEffect(() => {
    try {
      // Check if adsbygoogle is loaded, wait a bit if not (optional, basic check)
      if (window.adsbygoogle) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
      } else {
          // Optional: Retry or log if adsbygoogle isn't available immediately
          // console.warn("adsbygoogle not ready yet.");
          // setTimeout(() => {
          //     try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch(e) { console.error("AdSense retry push error:", e); }
          // }, 500); // Retry after 500ms
      }
    } catch (e) {
      console.error("AdSense push error:", e);
    }
  }, [adSlot]); // Re-run if adSlot changes, though unlikely for static placement

  return (
    <div style={{ margin: '20px 0' }}> {/* Wrapper for spacing */}
      {/* AdSense Ad Unit */}
      <ins className={className}
           style={style}
           data-ad-client={adClient}
           data-ad-slot={adSlot}
           data-ad-format={adFormat}
           data-ad-layout={adLayout}
           data-full-width-responsive={fullWidthResponsive.toString()}
      ></ins>
    </div>
  );
};

export default AdSenseUnit;
